import axios from 'axios';

import { URL } from '../constants/Consts';

const FetchConsts = {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete",
    PATCH: "patch"
};

const accessToken = sessionStorage.getItem('accessToken');

const axiosInstance = axios.create({
    baseURL: URL.API_CLIENT_URL,
    timeout: 6000,
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
});

console.log(axios.create);

const request = async (method: string, url: string, data = {}) => {
    try {
        const config: {
            url: string;
            method: string;
            params?: any;
            data?: any;
            headers?: any;  
        } = {
            url,
            method,     
            ...data,            
        };
        
        console.log("@@[Request Config]", config);
        const result = await axiosInstance(config);

        if (result) {
            return result?.data;
        }
    } catch (e) {
        console.log("error", e);
        if (e.response && e.response.status === 401) {
            // Redirect the user to the login page
            window.location.href = '/login';
        }

    } finally {
    }
};

const FetchJson = {
    get: (url: string, data?: object) => request(FetchConsts.GET, url, data),
    post: (url: string, data?: object) => request(FetchConsts.POST, url, data),
    put: (url: string, data?: object) => request(FetchConsts.PUT, url, data,),
    delete: (url: string, data?: object) => request(FetchConsts.DELETE, url, data),
    patch: (url: string, data?: object) => request(FetchConsts.PATCH, url, data),
};

export { FetchJson };
